/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable new-parens */
import React, { useEffect, useState, useRef } from 'react';

import configuration from '../../config';
import { elexity } from '../../utilities/BatteryAllocationGraphHelper';
import { useCampusMeta } from '../../context/CampusContextProvider';
import { useBatteryData } from '../../features/Devices/useDevicesQueries';
import { useLocalData } from '../../hooks/useLocalData';
import icon_edit from '../../assets/icon_edit.svg';
import icon_info from '../../assets/icon_info.svg';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

import './BatteryContent.scss';

const BatteryContent = ({ currentCampusId, openBatteryModal, showMobile }) => {
  const [showOutageRisk, setShowOutageRisk] = useState(false);

  const batteryAllocationRef = useRef(null);
  const batteryHistoryRef = useRef(null);
  const initialized = useRef(false);

  const { campusName } = useCampusMeta();
  const { data: batteryData } = useBatteryData(currentCampusId);
  const { getLocalData, APP_AUTH_STORAGE_KEY, APP_AUTH_TOKEN_KEY } = useLocalData();
  const getAuthHeaders = () => ({
    Authorization: `Bearer ${getLocalData(APP_AUTH_STORAGE_KEY)?.[APP_AUTH_TOKEN_KEY] ?? ''}`,
  });

  useEffect(() => {
    if (batteryData && !initialized.current) {
      initialized.current = true;
      batteryData.gridInterconnects.forEach((gx) => {
        elexity.gx.battery.init(
          batteryData,
          gx.gridInterconnectEntityKey,
          configuration['backend_host'] +
            '/admin/monitor/' +
            `${gx.gridInterconnectEntityKey}` +
            '/gxbattery/graphData/history',
          getAuthHeaders(),
          showMobile
        );
      });
    }
  }, [batteryData]);

  useEffect(() => {
    elexity.gx.battery.allocationGraph = {};
  }, [currentCampusId]);

  useEffect(() => {
    if (batteryData) {
      let gxId;

      batteryData.gridInterconnects.map((batteries) => {
        gxId = batteries.gridInterconnectEntityKey;
        setShowOutageRisk(batteries.backupPowerSupported);

        batteries.acBatteries = batteries.acBatteries.sort((a, b) => {
          if (a.entityKey - b.entityKey) {
            return 1;
          }
          if (a.entityKey < b.entityKey) {
            return -1;
          }
          return 0;
        });
      });

      if (
        batteryData.gridInterconnects &&
        batteryAllocationRef.current &&
        batteryHistoryRef.current
      ) {
        let interval = setInterval(() => {
          elexity.gx.battery.renderGraphs(
            batteryData,
            configuration['backend_host'] +
              '/admin/monitor/' +
              `${gxId}` +
              '/gxbattery/graphData/history',
            getAuthHeaders(),
            showMobile
          );
        }, 5000);

        return () => clearInterval(interval);
      }
    }
  }, [batteryData]);

  function formatDate(date) {
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 12);

    let formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  }

  return (
    <div>
      {batteryData && batteryData.gridInterconnects && (
        <>
          {batteryData.gridInterconnects.map((item, index) => {
            const renderHeading = () => {
              if (campusName) {
                return campusName;
              }
              return item.gridInterconnectEntityKey;
            };

            return (
              <React.Fragment key={`section-${index}`}>
                <div className="gx-container">
                  {batteryData.gridInterconnects.length > 1 && <div>z</div>}
                  <h3 className="gx-name">{renderHeading()}</h3>

                  <div className="totals-graph-container">
                    <div className="stats-graph-container">
                      <div className="battery-totals">
                        <p className="subhead total">All Battery Totals</p>

                        <div className="battery-total-detail soc">
                          <div className="battery-soc-graphic">
                            <img
                              className="icon"
                              src={require(
                                `../../assets/kiosk/battery${item.batteryDisplaySoc}.svg`
                              )}
                              alt="Current Battery SOC % graphic"
                              width="42"
                              height="42"
                            />
                          </div>

                          <div className="battery-soc-container">
                            <p className="category total">Battery SOC</p>
                            <p className="value total">{`${item.socPercent}% / ${item.sockWh} kWh`}</p>
                          </div>
                        </div>

                        <div className="battery-total-detail">
                          <p className="category total">Current Power</p>
                          <p className="value total">{`${item.realPowerkW} kW`}</p>
                        </div>

                        <hr />

                        <div className="battery-total-detail">
                          <p className="category total">Capacity</p>
                          <p className="value total">{`${item.capacitykWh} kWh`}</p>
                        </div>

                        <div className="battery-total-detail">
                          <p className="category total">Max Charge</p>
                          <p className="value total">{`${item.chargeCapacitykW} kW`}</p>
                        </div>

                        <div className="battery-total-detail">
                          <p className="category total">Max Discharge</p>
                          <p className="value total">{`${item.dischargeCapacitykW} kW`}</p>
                        </div>
                      </div>

                      <div className="battery-allocation-container">
                        <div className="allocation-header-container">
                          <div className="allocation-header">
                            <p className="subhead">Battery Allocation</p>

                            <div className="tooltip">
                              <img
                                src={icon_info}
                                alt="More information about battery allocation"
                                width="15"
                                height="15"
                              />
                              <div className="tooltip-text">
                                <p>
                                  The Battery Allocation chart shows how much of the battery energy
                                  capacity has been used up (<strong>Used</strong>), and how much
                                  remains (<strong>Available</strong>) for each of the use cases.
                                  Combined, these allocations will determine economic value from
                                  electricity savings or earnings.
                                </p>
                                <br />
                                <p>
                                  The allocations are optimized by Elexity for your site. However,
                                  if your battery is configured to provide backup power, you can
                                  change how much of the battery can be made available for economic
                                  use cases (Time of Use, Demand Charge Reduction) based on the risk
                                  of grid outage.
                                </p>
                                <br />
                                <p>
                                  <strong>Power</strong>: All the power that has not been used at
                                  any given time is available for Backup.
                                </p>
                                <br />
                                <p>
                                  <strong>DR (Demand Response) /VPP</strong>: How much is available
                                  for grid facing use cases.
                                </p>
                                <br />
                                <p>
                                  <strong>Time of Use</strong>: How much is available for managing
                                  Time Of Use tarriffs.
                                </p>
                                <br />
                                <strong>DCR (Demand-Charge Reduction)</strong>:
                                <br />
                                <p className="indent">
                                  <strong>Burst</strong>: Battery energy available to offset sudden
                                  increases in demand.
                                </p>
                                <br />
                                <p className="indent">
                                  <strong>Sustained</strong>: Battery energy available for reducing
                                  monthly peak demand.
                                </p>
                              </div>
                            </div>
                          </div>

                          {showOutageRisk && (
                            <div className="outage-risk">
                              <div className="title-edit">
                                <p className="group-subhead">Outage Risk</p>
                                <div
                                  onClick={() =>
                                    openBatteryModal('edit-battery', item.gridInterconnectEntityKey)
                                  }
                                >
                                  <img
                                    src={icon_edit}
                                    alt="Pencil icon to edit risk settings"
                                    width="15"
                                    height="15"
                                  />
                                </div>
                              </div>

                              <div className="outage-setting">
                                <div
                                  className={`${item.gridOutageRisk === 'None' ? 'active' : ''} pill risk none`}
                                >
                                  <p>None</p>
                                </div>

                                <div
                                  className={`${item.gridOutageRisk === 'Low' ? 'active' : ''} pill risk low`}
                                >
                                  <p>Low</p>
                                </div>

                                <div
                                  className={`${item.gridOutageRisk === 'Medium' ? 'active' : ''} pill risk medium`}
                                >
                                  <p>Medium</p>
                                </div>

                                <div
                                  className={`${item.gridOutageRisk === 'High' ? 'active' : ''} pill risk high`}
                                >
                                  <p>High</p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {!showMobile && (
                          <>
                            <div
                              id={`allocation-graph-${item.gridInterconnectEntityKey}`}
                              className="allocation-graph"
                              ref={batteryAllocationRef}
                            ></div>
                          </>
                        )}

                        {showMobile && (
                          <>
                            <table>
                              <tbody>
                                <tr>
                                  <th className="subhead">Category</th>
                                  <th className="subhead">Allocated</th>
                                  <th className="subhead">Available</th>
                                </tr>

                                {item.allocations.map((entry, index) => (
                                  <React.Fragment key={`${index}-entries`}>
                                    <tr>
                                      <td className="category">{entry.category}</td>
                                      <td className="allocated">{entry.allocated}</td>
                                      <td className="available">{entry.available}</td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </>
                        )}
                      </div>
                    </div>

                    <hr />

                    <div
                      id={`history-graph-${item.gridInterconnectEntityKey}`}
                      className="history-graph"
                      ref={batteryHistoryRef}
                    ></div>
                  </div>

                  {item.acBatteries.map((battery, index) => (
                    <React.Fragment key={`battery-${index}`}>
                      <div className="battery-container">
                        <div className="name-battery-container">
                          <p className="subhead">
                            {battery.longDescription && battery.longDescription !== null
                              ? battery.longDescription
                              : battery.entityKey}
                          </p>

                          <div className="battery-soc-graphic">
                            <img
                              className="icon"
                              src={require(
                                `../../assets/kiosk/battery${item.batteryDisplaySoc}.svg`
                              )}
                              alt="Current Battery SOC % graphic"
                              width="80"
                              height="80"
                            />
                          </div>
                        </div>

                        <div className="charging-container">
                          <p className="group-subhead">Charging</p>

                          <div className="all-categories">
                            <div className="categories">
                              <p className="category">Battery SOC</p>
                              <p className="value">{`${battery.socPercentage}% / ${battery.sockWh}kWh`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Current Power</p>
                              <p className="value">{`${battery.realPowerkW}kW`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Capacity</p>
                              <p className="value">{`${battery.capacitykWh}kWh`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Max Charge</p>
                              <p className="value">{`${battery.chargeCapacitykW}kW`}</p>
                            </div>

                            <div className="categories">
                              <p className="category">Max Discharge</p>
                              <p className="value">{`${battery.dischargeCapacitykW}kW`}</p>
                            </div>
                          </div>
                        </div>

                        <div className="cell-container">
                          <div className="cell-temp">
                            <p className="group-subhead">Cell Temp</p>

                            <div className="category-container">
                              <div className="pill cell max">
                                <p className="category">Max</p>
                                <p className="value">
                                  {battery.maxCellTemperature === null
                                    ? `--`
                                    : `${battery.maxCellTemperature.toFixed(2)}° C`}
                                </p>
                              </div>

                              <div className="pill cell avg">
                                <p className="category">Avg</p>
                                <p className="value">
                                  {battery.maxCellTemperature + battery.minCellTemperature / 2 ===
                                  'NaN'
                                    ? `--`
                                    : `${(battery.maxCellTemperature + battery.minCellTemperature / 2).toFixed(2)}° C`}
                                </p>
                              </div>

                              <div className="pill cell min">
                                <p className="category">Min</p>
                                <p className="value">
                                  {battery.minCellTemperature === null
                                    ? `--`
                                    : `${battery.minCellTemperature.toFixed(2)}° C`}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="cell-volt">
                            <p className="group-subhead">Cell Volt</p>

                            <div className="category-container">
                              <div className="pill cell max">
                                <p className="category">Max</p>
                                <p className="value">
                                  {battery.maxCellVoltage === null
                                    ? `--`
                                    : `${battery.maxCellVoltage.toFixed(2)} V`}
                                </p>
                              </div>

                              <div className="pill cell avg">
                                <p className="category">Avg</p>
                                <p className="value">
                                  {battery.maxCellVoltage + battery.minCellVoltage / 2 === 'NaN'
                                    ? `--`
                                    : `${(battery.maxCellVoltage + battery.minCellVoltage / 2).toFixed(2)} V`}
                                </p>
                              </div>

                              <div className="pill cell min">
                                <p className="category">Min</p>
                                <p className="value">
                                  {battery.minCellVoltage === null
                                    ? `--`
                                    : `${battery.minCellVoltage.toFixed(2)} V`}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}

                  <div className="battery-table">
                    <h3>Daily Charge/Discharge</h3>

                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Charge (kWh)</th>
                          <th>Discharge (kWh)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {item.dayActivities.map((activity, index) => (
                          <tr key={`battery-table-${index}`}>
                            <td>{formatDate(activity.date)}</td>
                            <td>{activity.chargekW}</td>
                            <td>{activity.dischargekW}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </>
      )}
    </div>
  );
};

export default BatteryContent;
